import { render, staticRenderFns } from "./PrivatePersonItem.vue?vue&type=template&id=77022a38"
import script from "./PrivatePersonItem.vue?vue&type=script&lang=js"
export * from "./PrivatePersonItem.vue?vue&type=script&lang=js"
import style0 from "./PrivatePersonItem.vue?vue&type=style&index=0&id=77022a38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports